import {createBrowserRouter} from "react-router-dom";

import MainLayout from "../layout/MainLayout";
import {MainScreen,PrivacyPolicy,TradingView,RedirectMobileApp,Faq,Fee,CategoryDetail,FaqDetail} from "../screens";
import HelpCenter from "../screens/HelpCenter";
import KycKampanyasi from "../screens/kyc-kampanyasi";
import KampanyaMerkezi from "../screens/kampanya-merkezi";

const routes = createBrowserRouter([
    {
        element:<MainLayout/>,
        children:[
            {
                path:"/",
                element:<MainScreen/>
            },
            {
                path:"privacy-policy",
                element:<PrivacyPolicy/>
            },
            {
                path:"tradingview",
                element:<TradingView/>
            },
            {
                path:"mobileApp",
                element:<RedirectMobileApp/>
            },
            {
                path:"sss",
                element:<Faq/>
            },
            {
                path:"destek-merkezi",
                element:<HelpCenter/>
            },
            {
                path:"destek-merkezi/:slug",
                element:<CategoryDetail/>
            },
            {
                path:"destek-merkezi/:slug/:faqSlug",
                element:<FaqDetail/>
            },
            {
                path:"fee",
                element:<Fee/>
            },
            {
                path:"kampanya-merkezi",
                element:<KampanyaMerkezi/>
            },
            {
                path:"kampanya-merkezi/kyc-kampanyasi",
                element:<KycKampanyasi/>
            }
        ]
    }
]);

export default routes;
